import { useEffect, useState } from 'react';
import { winnreAuth } from '../../../../utils/axios';
import { APIErrorCondition } from '../../../../constants';
import { toast } from 'react-toastify';

export const useData = () => {
    const [cashback, setCashback] = useState();
    const getCashback = () => {
        winnreAuth({
            url: '/winnre/user/deals/cashback-enquires/summary',
            method: 'GET'
        })
            .then((res) => {
                console.log('cashback', res);
                if (res?.status == APIErrorCondition) {
                    toast.error(res.message);
                    return;
                }
                setCashback(res?.totalCashback);
            })
            .catch((err) => {
                toast.error(err.message);
            });
    };

    useEffect(() => {
        getCashback();
    }, []);

    return { cashback };
};
